// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3075":"4676c5d6","7813":"4676c5d6"}[chunkId] + ".chunk.css";
};